// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.section_break > .contactum-fields {\n  border-bottom: 1px solid #ccc;\n}\n", ""]);
// Exports
module.exports = exports;
